// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { HashRouter as Router, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { generateKey } from "../src/common/crypto";
import { IAppError, IApplicationState, IAuthenticationState, IProject, ErrorCode } from "./models/applicationState";
import IAppErrorActions, * as appErrorActions from "./redux/actions/appErrorActions";
import { ErrorHandler } from "./react/components/common/errorHandler/errorHandler";
import IApplicationActions, * as applicationActions from "./redux/actions/applicationActions";
import { getStorageItem } from "./redux/middleware/localStorage";
import { KeyboardManager } from "./react/components/common/keyboardManager/keyboardManager";
import { MainContentRouter } from "./react/components/shell/mainContentRouter";
import 'bootstrap/dist/css/bootstrap.min.css';

// import Login from "../pages/login/login";
// import HeaderComponent from "./react/components/pages/header/header";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { patch } from './common/utils';

interface IAppProps {
    currentProject?: IProject;
    appError?: IAppError;
    loggedUser?: IAuthenticationState;
    actions?: IAppErrorActions;
    appSecurityTokenAction?: IApplicationActions;
}

function mapStateToProps(state: IApplicationState) {
    return {
        currentProject: state.currentProject,
        loggedUser: state.loggedInUser,
        appError: state.appError,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appSecurityTokenAction: bindActionCreators(applicationActions, dispatch),
        actions: bindActionCreators(appErrorActions, dispatch),
    };
}

/**
 * @name - App
 * @description - Root level component for VoTT Application
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class App extends React.Component<IAppProps> {
    constructor(props, context) {
        super(props, context);

        this.state = {
          currentProject: this.props.currentProject,
        };
    }

    public componentDidCatch(error: Error) {
        this.props.actions.showError({
            errorCode: ErrorCode.GenericRenderError,
            title: error.name,
            message: error.message,
        });
    }

    public render() {
        return (
            <Fragment>
                <Router>
                <ErrorHandler
                    error={this.props.appError}
                    onError={this.props.actions.showError}
                    onClearError={this.props.actions.clearError} />
                {/* Don't render app contents during a render error */}
                {(!this.props.appError || this.props.appError.errorCode !== ErrorCode.GenericRenderError) &&
                    <KeyboardManager>
                            <MainContentRouter loggedUser={this.props.loggedUser} />
                            <ToastContainer className="frtt-toast-container" role="alert"/>
                    </KeyboardManager>
                }
                </Router>
            </Fragment>
        );
    }
}
